class CustomTag extends HTMLElement {
  constructor() {
    super();

    this.tags =
      JSON.parse(
        this.querySelector("script.tags[type='application/json']").textContent
      ) || [];
    this.metaTags =
      JSON.parse(
        this.querySelector("script.metatags[type='application/json']")
          .textContent
      ) || [];

    this.tagLabel = this.querySelector(".tag-label");

    this.#init();
  }

  #init() {
    if (this.tags.length === 0 || this.metaTags.length === 0) return;

    this.#findtag();
  }

  #findtag() {
    this.tags.forEach((tag) => {
      this.metaTags.forEach((metaTag) => {
        if (tag === metaTag.handle) {
          this.style.display = "flex";
          this.tagLabel.textContent = metaTag.label;
          this.tagLabel.style.display = "flex";

          if (metaTag.image && !metaTag.image.includes("Liquid error")) {
            this.tagLabel.style.background = `url(${metaTag.image})`;
            this.tagLabel.style.backgroundRepeat = "no-repeat";
            this.tagLabel.style.backgroundSize = "cover";
            this.tagLabel.style.backgroundPosition = "center center";

            this.tagLabel.style.color = "transparent";
            this.tagLabel.classList.add("rounded");
          } else {
            this.tagLabel.style.background = metaTag.background;
            this.tagLabel.style.color = metaTag.color;
          }

          if (metaTag.rounded === "true") {
            this.tagLabel.classList.add("rounded");
          }
        }
      });
    });
  }
}

customElements.define("custom-tag", CustomTag);
